import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, CardBody, CardHeader, Col, Form, InputGroup, Row } from "react-bootstrap";
import "../../../index.css";
import { useEffect, useRef, useState } from "react";
import auxService from "../../../services/AuxService";
import { Condutor, CondutorInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { addCondutor, changeTracaoManifesto, removeCondutor, removerCondutorTodos }
    from "../../../features/manifestoSlice";
import { getUuidV4, goToFocus, validarCPFCNPJ } from "../../../utils/utils";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead, JvCaption, MakeMessageError } from "../../../components/Components";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const initialForm: CondutorInterface = {
    name: '',
    cpf: '',
    placa: '',
    tara: 0,
    capacidade: 0
}

const limite = 10;

export default function Condutores() {
    const dispatch = useDispatch();
    const [selectCondutores, setSelectCondutores] = useState<CondutorInterface[]>([]);
    const listaCondutores = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario?.tracao.condutores);
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);
    const [formCondutor, setFormCondutor] = useState<CondutorInterface>(initialForm)
    const selectedCondutorRef = useRef<HTMLSelectElement>(null);
    const nomeRef = useRef<HTMLInputElement>(null);
    const cpfRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const [saldo, setSaldo] = useState<number>(0);
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [selecionado, setSelecionado] = useState<number | string>('');

    const handleAddSelectedCondutor = () => {
        const value = selectedCondutorRef?.current?.value || '0'
        const condutor = selectedCondutorRef.current?.options[selectedCondutorRef.current?.selectedIndex].text || '|';
        let nome = '';
        let cpf = '';

        if (value === '0') {
            alertModal('Selecione um condutor!');
            return;
        }

        nome = condutor.split('|')[0].trim();
        cpf = condutor.split('|')[1].trim();

        if (validaPreenchimento(nome, cpf)) {
            dispatch(addCondutor({
                id: getUuidV4(),
                CPF: cpf,
                xNome: nome
            }));

            if (selectCondutores?.find(item => item.cpf === cpf)) {
                const motorista = selectCondutores.find(item => item.cpf === cpf);
                if (motorista) {
                    if (motorista.placa) {
                        dispatch(changeTracaoManifesto({ ['placa']: motorista.placa }));
                    }

                    if (motorista.renavam) {
                        dispatch(changeTracaoManifesto({ ['RENAVAM']: motorista.renavam }));
                    }

                    if (motorista.tara) {
                        dispatch(changeTracaoManifesto({ ['tara']: motorista.tara }));
                    }

                    if (motorista.capacidade) {
                        dispatch(changeTracaoManifesto({ ['capKG']: motorista.capacidade }));
                    }
                }
            }
        }
    }

    const handleAddCondutor = () => {
        if (validaPreenchimento(formCondutor.name, formCondutor.cpf)) {
            dispatch(addCondutor({
                id: getUuidV4(),
                CPF: formCondutor.cpf,
                xNome: formCondutor.name
            }));
            setFormCondutor(initialForm)
        }
    }

    const validaPreenchimento = (nome: string, cpf: string) => {
        if (nome === '') {
            goToFocus(nomeRef)
            alertModal('Informe o nome do condutor.');
            return false;
        }

        if (nome.length <= 1) {
            goToFocus(nomeRef)
            alertModal('O nome do condutor deve ter pelo menos 2 caracteres.');
            return false;
        }

        if (cpf === '') {
            goToFocus(cpfRef)
            alertModal('Informe o CPF do condutor.');
            return false;
        }

        if (!validarCPFCNPJ(cpf)) {
            goToFocus(cpfRef)
            alertModal('CPF inválido.');
            return false;
        }

        if (listaCondutores.length >= 10) {
            alertModal('Número máximo de condutores atingido.');
            return false;
        }

        if (listaCondutores.find((item: any) => item.CPF === cpf)) {
            alertModal('Condutor com esse CPF já foi adicionado.');
            return false;
        }
        return true;
    }

    const handleRemoveCondutor = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id);
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
            title: "Confirmação",
        })
        if (confirmed) {
            dispatch(removeCondutor(value.id.toString()));
        }
        setSelecionado('');
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setFormCondutor((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const removerTudo = async () => {
        if (listaCondutores.length > 0) {

            const confirmed = await confirm({
                message: <>Remover todos os condutores ?</>,
                title: "Confirmação",
            })
            if (confirmed) {
                dispatch(removerCondutorTodos());
            }
        }
    }

    useEffect(() => {
        auxService.getCondutores().then((res) => {
            setSelectCondutores(res.data)
        })
    }, []);

    useEffect(() => {
        setSaldo(listaCondutores.length);
    }, [listaCondutores])

    return (<>
        <Card>
            <CardHeader className="fw-bold">
                Dados dos Condutores
            </CardHeader>
            <CardBody className="p-2">
                <Row className="g-2 mb-2">
                    <Col md>
                        <Form.Group controlId="lista-condutores">
                            
                            <InputGroup>
                                <Form.Select ref={selectedCondutorRef} >
                                    <option value="0">Selecione um condutor</option>
                                    {selectCondutores?.map((item) => (
                                        <option key={item.id} value={item.id}>{item.name} | {item.cpf}</option>
                                    )
                                    )}
                                </Form.Select>
                                <Button type="button" onClick={handleAddSelectedCondutor}
                                    id="btn-add-condutor-selected"
                                    title="Adicionar um condutor a lista" >
                                    <FontAwesomeIcon icon={faPlus} />
                                </Button>
                            </InputGroup>
                        </Form.Group>
                    </Col>
                </Row>
                <Card className="mb-2">
                    <Card.Header>
                        Adicionar manualmente
                    </Card.Header>
                    <Card.Body>

                        <Row className="g-2 mb-3">
                            <Col md={6}>
                                <Form.Group controlId="nome-condutor">
                                    <Form.Label>Nome do condutor</Form.Label>
                                    <Form.Control name="name"
                                        onChange={handleChange} value={formCondutor.name}
                                        ref={nomeRef}
                                        maxLength={60} minLength={2} />
                                </Form.Group>
                            </Col>

                            <Col md >
                                <Form.Group controlId="cpf-condutor">
                                    <Form.Label>CPF</Form.Label>
                                    <InputGroup>
                                        <Form.Control name="cpf"
                                            onChange={handleChange} value={formCondutor.cpf}
                                            ref={cpfRef}
                                            maxLength={11}
                                        />
                                        <Button onClick={handleAddCondutor}
                                            id="btn-add-condutor"
                                            title="Adicionar um condutor a lista">
                                            <FontAwesomeIcon icon={faPlus} />
                                        </Button>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                
                <JTable>
                    <JvCaption>({saldo} de {limite} no máximo)</JvCaption>

                    <JTHead>
                        <tr>
                            <th className="text-center" style={{ width: '2.5rem' }}>
                                <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                            </th>
                            <th>Nome do condutor</th>
                            <th>CPF</th>
                        </tr>
                    </JTHead>
                    <JTBody>
                        {listaCondutores?.map((item: Condutor) => (
                            <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                <td className="text-center">
                                    <ButtonRemover onClick={() => handleRemoveCondutor({ id: item.id.toString(), title: item.xNome })} />
                                </td>
                                <td>{item.xNome}</td>
                                <td>{item.CPF}</td>
                            </tr>
                        ))}
                    </JTBody>
                </JTable>
            </CardBody>
        </Card>

        {ConfirmModal}
        {ModalMessageEl}
    </>)
}
